<div class="container mt-4">
  <!-- Recording Controls -->
  <div *ngIf="!audioRecorded" class="recording-controls text-center">
    <!-- Recording Timer -->
    <div *ngIf="isRecording" class="recording-timer mb-3">
      <span class="badge badge-danger">
        <ion-icon name="time"></ion-icon>
        {{ formatTime(recordingTime) }}
      </span>
    </div>

    <button *ngIf="!isRecording" class="btn btn-primary mr-2" (click)="startRecording()">
      <ion-icon name="mic"></ion-icon> Start Recording
    </button>

    <ng-container *ngIf="isRecording">
      <div class="d-flex">
        <button *ngIf="!isPaused" class="btn btn-warning mr-2" (click)="pauseRecording()">
          <ion-icon name="pause"></ion-icon> Pause
        </button>

        <button *ngIf="isPaused" class="btn btn-success mr-2" (click)="resumeRecording()">
          <ion-icon name="play"></ion-icon> Resume
        </button>

        <button class="btn btn-danger" (click)="stopRecording()">
          <ion-icon name="stop"></ion-icon> Stop
        </button>
      </div>
    </ng-container>
  </div>

  <!-- Recorded Audio Player -->
  <div *ngIf="audioRecorded" class="recorded-audio-player mt-3">
    <div class="card">
      <div
        class="card-body d-flex flex-column flex-sm-column flex-md-column flex-lg-row justify-content-between align-items-center"
      >
        <!-- Audio Player -->
        <audio #audioPlayer [src]="audioURL" controls class="mr-3 mb-3 flex-grow-1">
          Your browser does not support the audio element.
        </audio>

        <!-- Action Buttons -->
        <div class="audio-actions">
          <button class="btn btn-danger mr-2" (click)="deleteRecording()">
            <ion-icon name="trash"></ion-icon> Delete
          </button>

          <button class="btn btn-success" (click)="uploadRecording()">
            <ion-icon name="cloud-upload"></ion-icon> Upload
          </button>
        </div>
      </div>
    </div>

    <!-- Upload progress bar -->
    <div class="card mt-2" style="padding: 1rem" *ngIf="uploadPercentage">
      <div class="progress">
        <div
          class="progress-bar bg-warning"
          role="progressbar"
          [style.width.%]="uploadPercentage"
          [attr.aria-valuenow]="uploadPercentage"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {{ uploadPercentage }}%
        </div>
      </div>
    </div>
  </div>

  <span class="my-2 d-flex justify-content-center" *ngIf="!(isRecording || audioRecorded)">OR</span>

  <ng-container *ngIf="!(isRecording || audioRecorded)">
    <app-local-file-selector
      [type]="'audio'"
      (fileDropped)="onFileReceived($event)"
    ></app-local-file-selector>
  </ng-container>
</div>
